import { GestionActivos } from "../../components";

const GestionActivosPage = () => <GestionActivos />;

export default GestionActivosPage;
